import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!

  return (_ctx.getSearchedName.length <= 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "simple-element",
        style: {"word-break":"break-word"},
        innerHTML: _ctx.getElementName
      }, null, 8, _hoisted_1))
    : (_openBlock(), _createBlock(_component_q_item_label, {
        key: 1,
        class: "simple-element",
        style: {"word-break":"break-word"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSearchedName, (span, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              style: _normalizeStyle(span.style),
              innerHTML: span.text
            }, null, 12, _hoisted_2))
          }), 128))
        ]),
        _: 1
      }))
}